export default __webpack_public_path__ + "static/media/654.d5740051.gif";